import { createContext } from 'react';

export const AuthContext = createContext({
  isLoggedIn: false,
  userData: null,
  userPython: null,
  token: null,
  register: () => {},
  login: () => {},
  logout: () => {} 
});
